import { _initialState } from './_initialState';
import {
  addPromoItem,
  removePromoItem,
  updateTotalPrice
} from './actions';

const defaultData = {
  bogoItemInCart: null,
  currentPromoTier: 0,
  isPromoAchieved: false,
  progressMade: 0,
  promoCartItemsObj: {},
  promoCartQuantity: 0,
  promoCartValue: 0,
  promoSuccessLevel: '',
  secondListItemInCart: false
};

export const promoStore = (set, get) => ({
  ..._initialState,
  addPromoItem: (data) => addPromoItem(set, get, data),
  removePromoItem: (data) => removePromoItem(set, data),
  resetDiscounts: () => set({
    discounts: {}
  }, false, { type: 'resetDiscounts' }),
  resetPromoItems: () => {
    if (typeof window !== 'undefined') {
      window.LIFE_CYCLE_EVENT_BUS
        .trigger('promotion-products.items-to-add-to-cart', { data: [] });
      window.LIFE_CYCLE_EVENT_BUS
        .trigger('promotion-products.custom-promo-cart', defaultData);
    }
    return set(
      { promo: _initialState.promo },
      false,
      { type: 'resetPromoItems' }
    );
  },
  updatePromoTotal: (total) => set(
    { promo: { ...get().promo }, promoTotal: total },
    false,
    { type: 'updatePromoTotal' }),
  updateTotalPrice: (totalPriceData) => updateTotalPrice(set, totalPriceData),
  updateProductsWithRewardTiers: (data) => set({
    productsWithRewardTiers: data
  }, false, { type: 'updateProductsWithRewardTiers' }),
  updateFulfillmentProducts: (data) => set({
    fulfillmentProducts: data
  }, false, { type: 'updateFulfillmentProducts' }),
  updateDiscounts: (data) => set({
    discounts: data
  }, false, { type: 'updateDiscounts' }),
  openDrawer: () => set({
    showDrawer: true
  }),
  closeDrawer: () => set({
    showDrawer: false
  })
});
